<script>
import APIAttendance from "@/mixins/APIAttendance";
import APIClassType from "@/mixins/APIClassType";
import Filters from "./Filters";
export default {
  components: {
    Filters
  },
  mixins: [APIAttendance, APIClassType],
  data() {
    return {
      options: {
        fromDate: new Date().toISOString().split("T")[0],
        toDate: new Date().toISOString().split("T")[0],
        lastName: "",
        firstName: "",
        search: "",
        signMode: ["in"]
      },
      page: 0,
      perpage: 10000,
      search: "",
      userName: ""
    };
  },
  watch: {
    options: {
      handler: function() {
        this.refreshRecords();
      },
      deep: true
    }
  },
  created() {
    this.clear();
    this.addWWCCHeader();
  },
  methods: {
    addWWCCHeader: function() {
      if (this.permitted("wwcc")) {
        if (
          this.contactType === "visitor" ||
          this.contactType === "contractor"
        ) {
          let objWWCC = {
            text: "wwcc card",
            value: "wwcc_card"
          };
          this.complex.headers.insert(this.complex.headers.length - 2, objWWCC);
        }
      }
    },
    refreshRecords: async function() {
      let dateRange = {};
      dateRange.from = this.options.fromDate;
      dateRange.to = this.options.toDate;

      try {
        let options = [];
        if (dateRange.from && dateRange.to) {
          options.push("from_date=" + dateRange.from);
          options.push("to_date=" + dateRange.to);
        } else if (dateRange.from && !dateRange.to) {
          options.push("from_date=" + dateRange.from);
          options.push("to_date=" + dateRange.from);
        } else if (!dateRange.from && dateRange.to) {
          options.push("from_date=" + dateRange.to);
          options.push("to_date=" + dateRange.to);
        }

        options.push("holder_type=" + this.contactType);

        if (this.options.signMode && this.options.signMode.length === 1) {
          options.push("attendance_type=" + this.options.signMode[0]);
        }

        let fname = this.options.firstName;
        if (fname) {
          options.push("first_name=" + fname);
        }
        let lname = this.options.lastName;
        if (lname) {
          options.push("last_name=" + lname);
        }

        if (this.classid && this.classid.length > 0) {
          options.push("class=" + this.classid);
        }

        options.push("page=" + this.page);
        options.push("perpage=" + this.perpage);

        let res = await this.filterList(options);

        this.complex.items = res.map(obj => {
          if (obj.sign_in_date && obj.sign_out_date) {
            obj.completeStatus = "In / Out";
          } else if (obj.sign_in_date) {
            obj.completeStatus = "In";
          } else {
            obj.completeStatus = "Out";
          }
          return obj;
        });
      } catch (error) {
        this.$toast.error("Failed to fetch historical records!", "Error", {
          position: "topCenter"
        });
      }
    },
    handleMoreInfo(row) {
      this.$router.push({
        name: this.editMode,
        params: { object: row, id: row._id }
      });
    },
    handleDelete: async function(index, row) {
      let tempTableData = this.complex.items;
      let self = this;
      this.$swal({
        title: "Are you sure?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete it!",
        cancelButtonText: "No, Keep it!",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          let userId = row._id;
          self.deleteRow(tempTableData, index, userId);
          this.$swal(
            "Deleted",
            "You successfully deleted this file",
            "success"
          );
        } else {
          this.$swal("Cancelled", "Your file is still intact", "info");
        }
      });
    },
    deleteRow: async function(tempTableData, index, id) {
      if (index >= 0) {
        tempTableData.splice(index, 1);
        try {
          await this.deleteHisRecord(id);
        } catch (error) {
          this.$toast.error("Cannot get details!", "Error", {
            position: "topCenter"
          });
        }
      }
    },
    clear: function() {
      this.clearAdditional();
      this.options = {
        fromDate: new Date().toISOString().split("T")[0],
        toDate: new Date().toISOString().split("T")[0],
        lastName: "",

        firstName: "",
        search: "",
        signMode: ["in"]
      };
    },
    clearAdditional: function() {}
  }
};

Array.prototype.insert = function(index, item) {
  this.splice(index, 0, item);
};
</script>
